import { FC } from 'react';
import { CopyToClipboardWithNotifier } from '@edikk-edikk/copy-to-clipboard';
import { FormattedMessage } from 'react-intl';
import ArrowSvg from '@edikk-edikk/country-layout-black-icon/src/arrow.svg';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import { Button, ButtonSize, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { useAdvertDetailContext } from '#advertDetail/hooks';

const GalleryHeaderShare: FC = () => {
  const {
    advert: {
      url,
      name,
    },
  } = useAdvertDetailContext();

  const isAvailableShare = () => typeof navigator !== 'undefined' && 'share' in navigator;

  const handlerClick = async () => {
    if (!isAvailableShare()) {
      return;
    }

    await navigator.share({ url, title: name }).catch(() => null);
  };

  return (
    <CopyToClipboardWithNotifier
      text={url}
      message={<FormattedMessage defaultMessage="Link copied" />}
      isAvailable={!isAvailableShare()}
    >
      <Button variant={ButtonVariant.black} size={ButtonSize.lg} circle onClick={handlerClick} aria-label="Share">
        <SvgIcon Component={ArrowSvg} width={26} height={22} isWithoutFill />
      </Button>
    </CopyToClipboardWithNotifier>
  );
};

export { GalleryHeaderShare };
